import React from 'react';
import { connect } from 'react-redux';
import { Utils } from '../../util/utils';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { TileletCarousel } from '@vds/tiles';
import { TextLinkCaret } from '@vds/buttons';
import { redirectTo } from './../../action/redirection';

import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';

class Banner extends React.PureComponent {
  // constructor(props) {
  //   super(props);
  //   const queryString = window.location.search;
  //   this.newBanner = queryString.indexOf('newbanner') > -1;
  // }

  render() {
    let bannerList = [];
    const bannerListDesc = [];
    // var settings = {
    //   customPaging: function (i) {
    //     let slideNo = i + 1;
    //     return <button aria-label={'slide ' + slideNo + ' of ' + bannerList.length}>{i + 1}</button>;
    //   },
    //   dots: true,
    //   infinite: true,
    //   speed: 300,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   className: 'banner',
    //   autoplay: true, //false,
    //   autoplaySpeed: 10000,
    //   pauseOnHover: true,
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         swipeToSlide: true,
    //       },
    //     },
    //   ],
    // };
    const options = {
      decodeEntities: true,
      transform,
    };
    function transform(node, index) {
      if (node.type === 'tag' && node.name === 'li') {
        node.name = 'div';
      }
      if (node.type === 'tag' && node.name === 'img') {
        let path = node.attribs.src;
        node.attribs.style = 'width:430px; height:auto';
        // node.attribs.src = Utils.getDomainUrl() + path;
        node.attribs.src = Utils.getImagePath(path);
        node.attribs['tab-index'] = '-1';
        node.attribs.alt = '';
        return convertNodeToElement(node, index, transform);
      }
      if (node.type === 'tag' && node.name === 'h1') {
        node.name = 'h4';
        node.attribs.style = 'font-size:2.25rem;line-height:2.41rem';
      }
      // if (node.type === 'tag' && node.name === 'br') {
      //   node.attribs.style = 'display:none;';
      // }
      if (node.type === 'tag' && node.name === 'a') {
        node.attribs['tabIndex'] = '-1';
      }
    }

    if (this.props.bannerValue && this.props.bannerValue.bannerList) {
      this.props.bannerValue &&
        this.props.bannerValue.bannerList.map((bannerExpItems, index) => {
          bannerList.push(ReactHtmlParser(bannerExpItems.description, options));

          let sliderLink1 = bannerExpItems.description.split('href=');
          let sliderLink2 = sliderLink1[1].split('aria-label');
          let sliderLink3 = sliderLink2[0].split('"');
          let sliderLink = sliderLink3[1];

          bannerListDesc.push({
            title: {
              children: ReactHtmlParser(bannerExpItems.description, options),
            },
            id: `banner_carousel${index+1}`,
            key: index,
            backgroundColor: 'white',
            showBorder: true,
            onClick: () => {redirectTo(sliderLink, this.props.dispatch)},
          });
          return bannerList;
        });
    }

    return (
      <React.Fragment>
        <div className="bg-grey-5">
          <div className="relative hero-carousel-wraper">
            <div className="row hero-carousel" id="hero-carousel-slider" style={{ height: '560px' }}>
              {/* {!this.newBanner ? <Slider {...settings}>{bannerList}</Slider> : ''} */}

              {/* used vds tilelet carousel  */}
              {bannerListDesc.length > 0 ? (
                <TileletCarousel
                  layout="1UP"
                  gutter="24px"
                  peek="none"
                  paginationFill="light"
                  paginationInset="12px"
                  paginationDisplay={'persistent'}
                  aspectRatio="2:1"
                  data={bannerListDesc}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect()(Banner);
